module.exports = __webpack_public_path__ + "img/slide11.9fe2080d.jpg";